<script setup lang="ts">


import { useContentStore } from '~/stores/content.ts'
import ProductsCategoryCard from '~/components/cards/ProductsCategoryCard.vue'

const title = 'Kitchen Products'
const description = 'Explore our comprehensive hygiene solutions tailored for every area of your hospitality business.'
const image = '/images/kitchen.jpg'
const path = '/kitchens'

const $content = useContentStore()

const categories = computed(() => $content.productCategories)

</script>

<template>
<Frame class="sec-our-products relative overflow-hidden" w="max-w-92% tm:max-w-85% mx-auto gc-300px">

  <div class="grad absolute inset-0 w-full h-full">
    
  </div>
  <div class="sec-header">
    <div class="sec-title flex flex-col items-center justify-center ds:flex-row g-1.5 items-center justify-center t:max-w-80% t:mx-auto ds:max-w-100% ds:mx-auto ds:g-2!">
      <h2 class="fs-5! glh-2 fw-600 glh-1.5 mlx:fs-5! t:fs-6! ds:fs-6! ds:glh-2! ds:w-33%! dm:w-auto!">Our Products</h2>
      <p class="fs-05 tm:fs-1 ta-center text-gray-600 dark:text-gray-300 mx-auto ta-center ds:ta-left ds:w-66% ds:glh-1.5! dm:w-auto!">
        Explore our comprehensive hygiene solutions tailored for every area of your hospitality business. 
      </p>
    </div>
    <Frame class="sec-product-cards" w="max-w-100% ds:max-w-85% mx-auto grid mlx:gc-275px! t:gc-300px! ds:gc-400px! g-1 ">

      <ProductsCategoryCard v-for="i in categories" :key="i.slug" :title="i.name" :description="i.description" :image="i.image" :path="i.slug" />
    </Frame>
  </div>
</Frame>
</template>

<style lang="scss" scoped>
.sec-our-products {
  background-color: #184F87;
  border-radius:100px;
  padding: gr(3) gr(1) gr(4) gr(1);

  background-image: url('/images/kitchen-4.jpg');
  background-attachment: fixed;
  background-size: cover;

  .grad {
    background-color: #184F87;
    opacity: 0.9;
    z-index: 0;
  }

  .sec-header {
    position: relative;
    z-index: 1;

    >.sec-title {
      padding: gr(2) 0;
      color: white;  
      margin-bottom: gr(2);


      > h2 {
        color: white;
        font-weight: 400;

        font-family: var(--font-secondary);
      }

      > p {
        color: white;
        font-weight: 400;
      }
    }

  }
}
</style>